<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Отчёт покупка по товаров
          <v-divider class="mx-2" inset vertical></v-divider>



        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">
              <v-menu class="m-2"
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date1"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date1"
                  label="Дата 1"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date1"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_vozvratho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>




            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Поставщики"
            hide-details
            multiple
            solo
            prepend-icon="mdi-filter-menu-outline"
            :items="firmaho"
            item-text="nom"
            item-value="nom"
            class="m-4"
            @click:clear="get_vozvratho"
            v-model="filters.firma_nom" />


          </v-col>

          <v-col cols="12" md="3">

              <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date2"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="Дата 2"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_vozvratho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>



            <v-autocomplete class="m-4"
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo
             prepend-icon="mdi-filter-menu-outline"
             :items="categories"
             item-text="nom"
             item-value="nom"
             label="Категория"
             @click:clear="get_vozvratho"
             v-model="filters.kategoria_nom" />
          </v-col>
          <v-col cols="12" md="3">


              <v-autocomplete
              clearable
               item-color="primary"
               color="primary"
               hide-no-data
               hide-details
               multiple
               solo
               :items="joyho"
               item-text="mesto"
               item-value="mesto"
               label="Место"
               @click:clear="get_vozvratho"
               v-model="filters.mesto" />

               <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              hide-no-data
              hide-details
              class="m-4"
              v-model="searching"
              @click:clear="get_vozvratho"
              @keyup.enter="get_tovars_from_kod"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table dense
        :headers="headers"
        :items="filteredProducts"
        item-key="id_kharid"
        class="elevation-1"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
                    :search="searching"
         >




          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title ">Итого</th>
                  <th class="title ">{{Number( sumField('mikdor')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumField('summa')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>
              </tr>
          </template>

        </v-data-table>
      </v-container>



      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

  searching: "",
  search: "",
  s_smena: "",

  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
  ],

  joyho:[
            {mesto: 'Склад', value: '2'},
            {mesto: 'Магазин', value: '1'},

        ],

  categories:[],


  date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,



filters: {
fio: "",
nom: "",
valuta: "",
firma_nom: "",
comment: "",
kategoria_nom: "",
mesto:""
},



headers: [
        {
          text: 'Код',
          align: 'start',
          value: 'kod',
        },
        { text: 'Наименование', value: 'nom' },
        { text: 'Кол-во', value: 'mikdor' },
        { text: 'Цена закуп', value: 'narkhi_o' },
        { text: 'Скидка', value: 'skidka' },
        { text: 'Себестоимость', value: 'narkhi_a' },
        { text: 'Цена продажа', value: 'narkhi_f' },
        { text: 'Цена опт', value: 'narkhi_opt' },
        { text: 'Сумма', value: 'summa' },
        { text: 'Место', value: 'mesto'},
        { text: 'Дата', value: 'created_at' },


],

snack: false,
    snackColor: '',
    snackText: '',

loading: false,
vozvratho: [],
klents: [],
partners: [],
smeni: [],
vozvrat: {},
vozvrat_list: [],

furush_card: false,
sumfurush_card: true,
firmaho: [],

export_furush_fields: [

  {
      'title': 'Код',
      'name': 'kod',
      'width': '20',
      'type': 'Number',
      },
      {
      'title': 'Наименование',
      'name': 'nom',
      'width': '50'

      },

      {
      'title': 'Количество',
      'name': 'mikdor',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Сумма',
      'name': 'summa',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Сумма убытка',
      'name': 'ub',
      'type': 'float',
      'width': '20'
      },

],

export_sumfurush_fields: [

  {
      'title': '№',
      'name': 'id_sum_vozvrat',
      'width': '20',
      'type': 'Number',
      },
      {
      'title': 'Клиент',
      'name': 'fio',
      'width': '35'

      },

      {
      'title': 'Сумма',
      'name': 'sum_v',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Скидка',
      'name': 'skidka',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Наличий',
      'name': 'nakd',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Из долг',
      'name': 'az_karz',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Дата',
      'type': 'Date',
      'name': 'created_at',
      'width': '20'
      },

],


}),

mounted(){

  this.get_vozvratho();

  this.get_firmaho();
  this.get_categories();
},

methods: {

    get_categories(){
          this.loading = true;
        axios.get('/api/get_categories',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.categories = response.data.categories;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho1',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },
  sumField(key) {
  return  this.filteredProducts.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  sumFurush(key) {
  return  this.vozvrat_list.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },






  get_vozvratho(){
          this.vozvratho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)
          this.loading = true;


          axios.get('/api/get_kharid_po_tovar/'+this.date1+'/'+this.date2,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.vozvratho = response.data.kharid
                                    this.loading = false;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.vozvratho = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.vozvratho = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
                  },

  search_mol(){
      this.vozvratho = [];
      this.loading = true;
      axios.post('/api/searching_mol_v', {
          search: this.searching
      })
      .then(response => {
          if(response.data.status){
              this.loading = false;
              this.searching = '';
               this.vozvratho = response.data.searching;
          }else{
              this.loading = false;
              this.snack = true
              this.snackColor = 'error'
              this.snackText = "Ошибка получения peremeshenies"
              setTimeout(() => {
                  this.snack = false;
              }, 2000);
          }
      })
      .catch(error => {
          this.loading = false;
          this.snack = true
          this.snackColor = 'error'
          //this.snackText = error.response.data.message;
              setTimeout(() => {
                  this.snack = false;
              }, 2000);
      });
      this.searching = '';

  },



  back_to_sumfurush(){
      this.furush_card = false;
      this.sumfurush_card = true;
  },

  get_tovars_from_kod(){

    this.vozvratho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)
          this.loading = true;


          axios.get('/api/search_tovar_from_kod/'+this.date1+'/'+this.date2+'/'+this.searching,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.vozvratho = response.data.kharid
                                    this.loading = false;
                                    this.searching = "";
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.vozvratho = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.vozvratho = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });

  }



},

computed: {

  filteredProducts() {
let filter = this.vozvratho.filter((id_kharid) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_kharid[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},


}

}
</script>

<style  scoped>

</style>



